import styled, { css, keyframes } from "styled-components";

const blinkSuccess = keyframes`
  to { fill: #00ff00; }
`;

const blinkError = keyframes`
  to { fill: #ff0000; }
`;

export const MobileShareButton = styled.button`
  display: inline-block;
  width: 40px;
  height: 40px;
  background-color: #333333;
  text-indent: 0;
  padding: 4px;
  border: none;
  svg {
    ${props =>
      props.error &&
      css`
        animation: ${blinkError} 250ms steps(2, jump-none) infinite;
      `}
    ${props =>
      props.success &&
      css`
        animation: ${blinkSuccess} 250ms steps(2, jump-none) infinite;
      `}
  }
`;

export const CopyButton = styled.span`
  display: inline-block;
  width: 34px;
  height: 34px;
  background-color: #333333;
  text-indent: 0;
  border: none;
  padding: 4px;
  svg {
    padding: 6px;
    ${props =>
      props.copied &&
      css`
        animation: ${blinkSuccess} 250ms steps(2, jump-none) infinite;
      `}
  }
`;
